"use strict";

exports.__esModule = true;
exports.SingletonCalendarEventForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _CalendarEventNameField = require("../CalendarEvent/CalendarEventNameField");
var _CalendarEventClassificationStateField = require("../CalendarEvent/CalendarEventClassificationStateField");
var _SingletonCalendarEventStartTimeField = require("./SingletonCalendarEventStartTimeField");
var _SingletonCalendarEventEndTimeField = require("./SingletonCalendarEventEndTimeField");
var _Core = require("../../Core");
var _Utils = require("../../../Utils");
var _class, _SingletonCalendarEventForm;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Condition = function Condition(_ref) {
  var when = _ref.when,
    is = _ref.is,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: when,
    subscription: {
      value: true
    }
  }, function (_ref2) {
    var value = _ref2.input.value;
    return value === is || typeof is === "function" && is(value) ? children : null;
  });
};

/**
 * Shows a form which can edit a calendar event.
 */
var SingletonCalendarEventForm = exports.SingletonCalendarEventForm = (0, _Core.withTranslator)(_class = (_SingletonCalendarEventForm = /*#__PURE__*/function (_Component) {
  function SingletonCalendarEventForm() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSubmit = function (input) {
      _this.debounceHandleSubmit(input);
    };
    _this.debounceHandleSubmit = (0, _Utils.debounce)(function (input) {
      var onSubmit = _this.props.onSubmit;
      onSubmit(input);
    }, {
      delay: 500
    } // this is debounced to prevent creating multiple events on calendar when user is clicking button few times in a second
    );
    _this.handleValidate = function (input) {
      var errors = {};
      if (!input.payload || !input.payload.name) {
        if (!errors.payload) {
          errors.payload = {};
        }
        errors.payload.name = "Name is required";
      }
      if (!input.interval || !input.interval.startMillis) {
        errors.interval = errors.interval || {};
        errors.interval.startMillis = "Start time is required";
      }
      if (!input.interval || !input.interval.endMillis) {
        errors.interval = errors.interval || {};
        errors.interval.endMillis = "End time is required";
      }
      return errors;
    };
    return _this;
  }
  _inheritsLoose(SingletonCalendarEventForm, _Component);
  var _proto = SingletonCalendarEventForm.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      translate = _this$props.translator.translate,
      event = _this$props.event,
      onDelete = _this$props.onDelete,
      onCancel = _this$props.onCancel;
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: this.handleSubmit,
      validate: this.handleValidate,
      initialValues: event
    }, function (_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        invalid = _ref3.invalid;
      return /*#__PURE__*/_react["default"].createElement("form", {
        "data-testid": "SingletonCalendarEventForm",
        onSubmit: handleSubmit
      }, !event.id && /*#__PURE__*/_react["default"].createElement("h4", null, translate("SingletonCalendarEventForm.title.newEvent", "New Holiday")), event.id && /*#__PURE__*/_react["default"].createElement("h4", null, translate("SingletonCalendarEventForm.title.editEvent", "Edit Holiday")), /*#__PURE__*/_react["default"].createElement(_CalendarEventNameField.CalendarEventNameField, {
        prefix: "payload"
      }), /*#__PURE__*/_react["default"].createElement(Condition, {
        when: "type",
        is: "Classification"
      }, /*#__PURE__*/_react["default"].createElement(_CalendarEventClassificationStateField.CalendarEventClassificationStateField, {
        prefix: "payload"
      })), /*#__PURE__*/_react["default"].createElement(_SingletonCalendarEventStartTimeField.SingletonCalendarEventStartTimeField, null), /*#__PURE__*/_react["default"].createElement(_SingletonCalendarEventEndTimeField.SingletonCalendarEventEndTimeField, null), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        type: "submit",
        icon: "floppy-disk",
        intent: "primary",
        disabled: invalid
      }, translate("SingletonCalendarEventForm.saveButton", "Save")), event.id && /*#__PURE__*/_react["default"].createElement(_core.Button, {
        type: "button",
        icon: "delete",
        onClick: onDelete
      }, translate("SingletonCalendarEventForm.deleteButton", "Delete")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        type: "button",
        onClick: onCancel
      }, translate("SingletonCalendarEventForm.cancelButton", "Cancel"))));
    });
  };
  return SingletonCalendarEventForm;
}(_react.Component), _SingletonCalendarEventForm.defaultProps = {
  translator: undefined
}, _SingletonCalendarEventForm)) || _class;